module.exports = ".card-grid {\n    width: 320px;\n    height: 100%;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/main/home-grid/home-grid.component.css
// module id = ./src/app/main/home-grid/home-grid.component.css
// module chunks = main